import type { Bot, ChannelScopeStatus, SubscriptionPlanItem } from './types';

export function botCanStart(bot: Bot): boolean {
  return bot.channels.some((c) => c.status === 'active') && bot.desiredState !== 'running';
}

export function botNeedsAttention(bot: Bot): boolean {
  return bot.health.drift || bot.authorization?.needsReauth === true;
}

export function planKey(item: Pick<SubscriptionPlanItem, 'type' | 'version'>): string {
  return `${item.type}@${item.version}`;
}

export function desiredTypes(plan: SubscriptionPlanItem[]): Array<{ type: string; version: string }> {
  return plan.filter((item) => item.desired).map((item) => ({ type: item.type, version: item.version }));
}

export function scopeCoverage(status: ChannelScopeStatus): { granted: number; required: number } {
  return { granted: status.granted.length, required: status.required.length };
}

export function missingFromPlan(plan: SubscriptionPlanItem[]): string[] {
  const missing = new Set<string>();
  for (const item of plan) {
    for (const scope of item.runtime?.missingScopes ?? []) missing.add(scope);
  }
  return [...missing];
}
